import { defineComponent } from "@vue/composition-api";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
export default defineComponent({
  name: "MortgageCalculatorsToolbar",
  components: {
    SimpleButton
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    hasErrors: {
      type: Boolean,
      default: false
    },
    clearSelectionProps: {
      type: Object,
      default: () => ({
        disabled: false
      })
    },
    resetToDefaultProps: {
      type: Object,
      default: () => ({
        disabled: false,
        loading: false,
        loadingSucceeded: true
      })
    },
    setDefaultProps: {
      type: Object,
      default: () => ({
        disabled: false,
        loading: false,
        loadingSucceeded: true
      })
    },
    reportProps: {
      type: Object,
      default: () => ({
        disabled: false,
        loading: false,
        loadingSucceeded: true
      })
    },
    showCalculate: {
      type: Boolean,
      default: true
    },
    showPreview: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const handleClearSelection = () => emit("clear-selection");
    const handleResetToDefault = () => emit("reset-to-default");
    const handleSetDefault = () => emit("set-default");
    const handleRunReport = () => emit("run-report");
    return {
      handleClearSelection,
      handleResetToDefault,
      handleSetDefault,
      handleRunReport
    };
  }
});